import { CompanyOrder, CompanySortBy } from '../types/company.types';
import { localStorageUtil } from '../utils/local-storage.util';

export const companiesSortStore = localStorageUtil<{
  field: CompanySortBy | null;
  sortMode: CompanyOrder | null;
}>('companiesSortState');
